import { authHeader, httpHelper } from '../helpers';
import { post } from 'axios';

export const dashboardService = {
    opbTotalCnt,
    opbDailyCnt,
    opbRegionCnt,
    opbMngCnt,
    opbTotalCntXls,
    opbDailyCntXls,
    opbRegionCntXls,
    opbMngCntXls,
    opbOfficeCnt,
    opbSiteCnt,
    opbStats,
    opbMapMarkerList
};

function opbTotalCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbTotalCnt`, formData, headers);
}

function opbDailyCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbDailyCnt`, formData, headers);
}

function opbRegionCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbRegionCnt`, formData, headers);
}

function opbMngCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbMngCnt`, formData, headers);
}

function opbTotalCntXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/dashboard/opbTotalCntXls`, formData, headers);
}

function opbDailyCntXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/dashboard/opbDailyCntXls`, formData, headers);
}

function opbRegionCntXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/dashboard/opbRegionCntXls`, formData, headers);
}

function opbMngCntXls(formData) {
    const headers = {headers: authHeader(), responseType: 'blob'};
    return post(httpHelper.getApiUrl()+`/dashboard/opbMngCntXls`, formData, headers);
}

function opbOfficeCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbOfficeCnt`, formData, headers);
}

function opbSiteCnt(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbSiteCnt`, formData, headers);
}

function opbStats(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbStats`, formData, headers);
}

function opbMapMarkerList(formData) {
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/dashboard/opbMapMarkerList`, formData, headers);
}